import React from 'react';
import { Redirect, Switch, useRouteMatch, Route } from 'react-router-dom'
import EpicMenu from '../../componentes/Menus/EpicMenu';
import Menu from '../../componentes/Menus/Perfil';
import Documentos from './documentos';
import Pisca from '../UserPage/pisca'
import Herramientas from './herramienta'
import Actividades from './actividades'
import Asistencias from './asistencias'
import Data from './data';

function Perfil() {
    let { path, url } = useRouteMatch()
    return(
  <>
    <div className='header'>
      <EpicMenu />
      <div className='inline'>Perfil</div>
    </div>
    <div className='body'>
        <Menu url={url} />
        <section>
            <Switch>
                <Route exact path={path} component={Actividades} />
                <Route path={`${path}/pisca`} component={Pisca} />
                <Route path={`${path}/herramientas`} component={Herramientas} />
                <Route path={`${path}/datos`} component={Data} />
                <Redirect exact from={`${path}/perfil`} to={`${url}/datos`} />
                <Route path={`${path}/asistencias`} component={Asistencias} />
                <Route path={`${path}/documentos`} component={Documentos} />
            </Switch>
        </section>
    </div>
    <div className="footer" >
        <div className="footer1" >
        </div>
        <div className="footer2" ></div>
    </div>
  </>
    )
}

export default Perfil;
